/**
 * A ordem do acervo — preferência POR USUÁRIO, persistida no localStorage. O padrão é o
 * compromisso mais próximo (prazo ou audiência): é o que pede atenção ao abrir a tela.
 * Quem troca para "Mais recentes" a reencontra assim na próxima visita.
 */
import { useCallback, useMemo, useState } from 'react';

import { chaveDePreferencia, gravarPreferencia, lerPreferencia } from '@/lib/preferenciasUsuario';

const STORAGE_PREFIX = 'jurisapp.acervo.ordem';

export function useOrdemDoAcervo(userId: string | undefined) {
  const chave = chaveDePreferencia(STORAGE_PREFIX, userId);
  // Escolha da sessão indexada pela chave: a troca de conta não herda a do outro.
  const [escolhas, setEscolhas] = useState<Record<string, boolean>>({});

  const persistido = useMemo(() => {
    const cru = lerPreferencia(chave);
    return cru === null ? null : cru === 'vencimento';
  }, [chave]);

  const porVencimento = (chave ? escolhas[chave] : undefined) ?? persistido ?? true;

  const setPorVencimento = useCallback(
    (valor: boolean) => {
      if (chave) setEscolhas((anteriores) => ({ ...anteriores, [chave]: valor }));
      gravarPreferencia(chave, valor ? 'vencimento' : 'recentes');
    },
    [chave],
  );

  return [porVencimento, setPorVencimento] as const;
}
